<template>
  <BannerSection class="hero-wrapper bg-dark" :style="{backgroundImage: `url(${imgurl})`}">
      <slot>I'm a hero section!</slot>
  </BannerSection>
</template>

<script>
import BannerSection from './BannerSection.vue'

export default {
  name: 'HeroSection',
  components: {
    BannerSection
  },
  props: ['imgurl']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
